<div mat-dialog-title>
  <span *ngIf="data.event.id">
    Termin bearbeiten
  </span>
  <span *ngIf="!data.event.id">
    Termin erstellen
  </span>
</div>

<div mat-dialog-content>
  <div class="flex flex-wrap -mx-2" [formGroup]="eventForm">
    <div class="w-full px-2" *ngIf="!data.event.cooperation.id">
      <div class="w-full">
        <label>Kooperation</label>
        <input placeholder="Suche nach Kooperation" type="text" class="styled dark" [matAutocomplete]="coopAutocomplete" formControlName="cooperation">
        <mat-autocomplete #coopAutocomplete [displayWith]="displayCooperationFn">
          <mat-option *ngFor="let coop of (cooperations$ | async)?.results" [value]="coop">
            <span>{{ coop.name }}</span>
          </mat-option>
        </mat-autocomplete>
        <div (click)="addNewCooperation()" class="text-sm mb-3 text-blue-500 font-bold underline cursor-pointer">
          + Neue Kooperation erstellen
        </div>

      </div>
    </div>
    <div class="w-full px-2">
      <label>Doing</label>
      <input class="styled dark" type="text" formControlName="title"/>
    </div>
    <div class="w-full px-2">
      <label>Briefing</label>
      <textarea class="styled dark" formControlName="briefing"></textarea>
    </div>
    <div class="w-full px-2">
      <label>Coupon</label>
      <input class="styled dark" type="text" formControlName="coupon"/>
    </div>
    <div class="w-full px-2">
      <label>Dokumente</label>
      <div class="w-full p-2 bg-gray-700 text-white rounded">
        <app-document (onremove)="removeDocument(medium)" *ngFor="let medium of medias" [object]="medium"></app-document>
      </div>
      <div (click)="addDocument()" matRipple class="inline-block text-sm py-2 px-4 bg-blue-400 text-white font-bold cursor-pointer rounded mt-2">
        <span class="iconify inline" data-icon="fa:plus"></span> Dokument hinzufügen
      </div>
        <input type="file" class="hidden" multiple #fileInput (change)="filesSelected($event)" />
    </div>

    <div class="w-full px-2">
      <label>Konditionen</label>
      <textarea class="styled dark" formControlName="conditions"></textarea>
    </div>
    <div class="w-2/3 px-2">
      <label>Umsatz</label>
      <app-currency-input [disabled]="!event.changeable" [value]="event.fee" [currency]="event.currency" (valueChanged)="updateFee($event)" (currencyChanged)="updateCurrency($event)"></app-currency-input>
    </div>
    <div class="w-1/3 px-2">
      <label>KSK</label>
      <select formControlName="socialContributionType" class="styled dark">
        <option value="not_needed">Fällt nicht an</option>
        <option value="included">Inklusive KSK</option>
        <option value="not_included">Zuzüglich KSK</option>
          <option value="in_transit">KSK als durchlaufender Posten</option>
        <option value="paid_by_customer">Wird vom Kunden bezahlt</option>
          <option value="paid_by_artist">Influencer führt ab</option>
      </select>
    </div>
    <div class="w-1/2 px-2">
      <label>Abrechnungsart</label>
      <select class="styled dark" formControlName="accountingType">
        <option [value]="null">Nicht überschreiben</option>
        <option [value]="'normal'">Zahlung an Artist</option>
        <option [value]="'settlement'">Zahlung an Lionflence</option>
      </select>
    </div>
    <div class="w-1/2 px-2">
      <label>Social-Media-Konto</label>
      <select class="styled dark" formControlName="profile">
        <option [value]="null">Kein Profil gewählt</option>
      </select>
    </div>
    <div class="w-1/3 px-2">
      <label>Status</label>
      <select class="styled dark" formControlName="state">
        <option [value]="'draft'">Entwurf</option>
        <option [value]="'published'">Freigegeben</option>
      </select>
    </div>
    <div class="w-2/3 px-2">
      <label>Datum</label>
      <input *ngIf="eventForm.get('fullday').value" type="text" formControlName="deadline" class="styled dark" placeholder="Wähle ein Datum" [matDatepicker]="deadlinePicker" (click)="deadlinePicker.open()">
      <mat-datepicker #deadlinePicker startView="year"></mat-datepicker>

      <input *ngIf="!eventForm.get('fullday').value" type="text" formControlName="deadline" (click)="showPicker()" class="styled dark" [ngxMatDatetimePicker]="picker" placeholder="Wähle ein Datum">
      <ngx-mat-datetime-picker [defaultTime]="[23,59,59]" [stepMinute]="15" #picker></ngx-mat-datetime-picker>
      <mat-checkbox formControlName="fullday">Ganztägig</mat-checkbox>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div class="w-full text-right">
    <div (click)="save()" matRipple class="inline-block py-2 px-4 cursor-pointer font-bold bg-blue-500 text-white rounded">
      Speichern
    </div>
  </div>
</div>

<div mat-dialog-close class="dialog-closer"></div>


